import React, { useState } from "react";
import { HashLink as Link } from "react-router-hash-link";

function Navbar() {

  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav>

      <div
        className="hamburger-menu"
        onClick={toggleMenu}
      >
        <svg width="30" height="30" viewBox="0 0 30 30">
          <rect className="line" width="30" height="4" x="0" y="5" />
          <rect className="line" width="30" height="4" x="0" y="13" />
          <rect className="line" width="30" height="4" x="0" y="21" />
        </svg>
      </div>

      <ul className={`hamburger-nav-menu ${menuOpen ? "active" : "hidden"}`}>
        <li><Link to="/#home" onClick={closeMenu}>Home</Link></li>
        <li><Link to="/beavers#beavers" onClick={closeMenu}>Beavers</Link></li>
        <li><Link to="/cubs#cubs" onClick={closeMenu}>Cubs</Link></li>
        <li><Link to="/scouts#scouts" onClick={closeMenu}>Scouts</Link></li>
        <li><Link to="/badges#badges" onClick={closeMenu}>Badges & Awards</Link></li>
        <li><Link to="/files#files" onClick={closeMenu}>Useful Forms</Link></li>
        <li><Link to="/contact#contact" onClick={closeMenu}>Contact Us</Link></li>
        <li><Link to="/calendar#calendar" onClick={closeMenu}>Programme & Calendar</Link></li>
        <li><Link to="/replacements#products" onClick={closeMenu}>Replacement Uniform</Link></li>
      </ul>

      <ul className="nav-menu">
        <li><Link to="/#home">Home</Link></li>

        <li className="dropdown">
          <a href="#" className="dropbtn">Sections</a>
          <div className="dropdown-content">
            <Link to="/beavers#beavers">Beavers</Link>
            <Link to="/cubs#cubs">Cubs</Link>
            <Link to="/scouts#scouts">Scouts</Link>
          </div>
        </li>

        <li className="dropdown">
          <a href="#" className="dropbtn">Uniforms</a>
          <div className="dropdown-content">
            <Link to="/beavers#uniform-info">Beaver Uniform</Link>
            <Link to="/cubs#uniform-info">Cub Uniform</Link>
            <Link to="/scouts#uniform-info">Scout Uniform</Link>
          </div>
        </li>

        <li><Link to="/badges#badges">Badges & Awards</Link></li>
        <li><Link to="/files#files">Useful Forms</Link></li>
        <li><Link to="/contact#contact">Contact Us</Link></li>
        <li><Link to="/calendar#calendar">Programme & Calendar</Link></li>
        <li><Link to="/replacements#products">Replacement Uniform</Link></li>
      </ul>

    </nav>
  );
}

export default Navbar;